"use client";

import { useRef } from "react";

/** -1 (previous), 1 (next) or 0: a mostly sideways move of at least 40 px. */
export function swipeStep(dx: number, dy: number): -1 | 0 | 1 {
  if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return 0;
  return dx < 0 ? 1 : -1;
}

/**
 * Touch handlers that step a viewer left and right. `swiped()` is true right after a swipe, so a
 * click the browser fires at its end does not count as a tap (and never closes the viewer).
 */
export function useSwipe(onStep: (delta: -1 | 1) => void) {
  const start = useRef<{ x: number; y: number } | null>(null);
  const last = useRef(0);
  return {
    onTouchStart: (e: React.TouchEvent) => {
      const t = e.touches[0];
      start.current = t ? { x: t.clientX, y: t.clientY } : null;
    },
    onTouchEnd: (e: React.TouchEvent) => {
      const t = e.changedTouches[0];
      if (!start.current || !t) return;
      const delta = swipeStep(t.clientX - start.current.x, t.clientY - start.current.y);
      start.current = null;
      if (delta === 0) return;
      last.current = Date.now();
      onStep(delta);
    },
    swiped: () => Date.now() - last.current < 500,
  };
}
